
import brandWhiteLogo from '../../../assets/images/logos/bluesite-hub-white.png'
import {
  BrandHeadline,
  BrandImage,
  BrandPanel,
  BrandPanelContent,
  BrandPill,
  BrandPillGroup,
  BrandSubtitle,
  Content,
  Container,
  ContainerForm,
} from './styled'

type AuthVariant = 'admin' | 'evaluated'

interface AuthLayoutProps {
  children: React.ReactNode
  variant?: AuthVariant
}

const layoutContent: Record<AuthVariant, { headline: string; subtitle: string; pills: string[] }> = {
  admin: {
    headline: 'Talento, diagnósticos y decisiones con más claridad.',
    subtitle: 'Una experiencia diseñada para operar procesos de talento con resultados confiables y agilidad tecnológica.',
    pills: ['Diagnóstico', 'Analítica', 'IA aplicada'],
  },
  evaluated: {
    headline: 'Responde tus pruebas en un entorno claro, confiable y simple.',
    subtitle:
      'Un acceso pensado para participantes y evaluados, con foco en concentración, facilidad de uso y acompañamiento durante la experiencia.',
    pills: ['Evaluaciones', 'Retroalimentación', 'Experiencia guiada'],
  },
}

const AutLayout = ({ children, variant = 'admin' }: AuthLayoutProps): JSX.Element => {
  const content = layoutContent[variant]

  return (
    <Container>
      <Content>
        <ContainerForm>
          {children}
        </ContainerForm>
        <BrandPanel variant={variant}>
          <BrandPanelContent>
            <BrandImage src={brandWhiteLogo} alt="Bluesite HR Hub" />
            <BrandHeadline>{content.headline}</BrandHeadline>
            <BrandSubtitle>{content.subtitle}</BrandSubtitle>
            <BrandPillGroup>
              {content.pills.map((pill) => (
                <BrandPill key={pill}>{pill}</BrandPill>
              ))}
            </BrandPillGroup>
          </BrandPanelContent>
        </BrandPanel>
      </Content>
    </Container>
  )
}

export default AutLayout
